module.exports = __webpack_public_path__ + "img/pie-chart-04.b137209f.svg";